<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <component :is="view"></component>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 工具函数
import { Formats } from "@/assets/js";
//* 页面
import PredictMiddle from "./childrens/middle/index.vue";
import PredictModel from "./childrens/model/index.vue";

//* 获取Route
const route = useRoute();
//* 当前页面
const view = computed(() => {
    if (!Formats.query(route.query.id)) return PredictMiddle;
    else {
        return PredictModel;
    }
});
</script>
